<template>
<v-dialog
    v-model="mess_flg"
    max-width="700px"
>
    <v-card>
        <v-img
          src="/images/GPT.png"
        ></v-img>

        <v-card-title>
            こちらの機能は有料機能となります。
        </v-card-title>
        <v-card-text>
            有料サービスをお申し込みいただくと、プレスリリース原稿を保存したりWord形式でダウンロードすることができます。
        </v-card-text>
        <v-card-actions style="justify-content:center">
            <v-btn
                text
                @click="open_win"
                outlined
            >
                面談予約
            </v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>
<script>
export default {
    data : function(){
        return {
            mess_flg : false,
        }
    },
    methods : {
        open : function(){
            this.mess_flg = true;
        },
        open_win : function(){
            window.open('https://timerex.net/s/qlipper/18c7c284', '_blank');
        },
    },
}
</script>
